import { useMemo } from 'react';

import { ISupportMenuItem } from '../SupportMenu';
import { HEADER_DATA_TEST_ID } from '@/features/layouts/MainLayout/testIds';
import { envs } from '@/shared/constants/envs';
import { useUser } from '@/store/user/hooks';
import { useTranslate } from '@/i18n/useTranslate';

export const useSupportItems = () => {
  const { t } = useTranslate('common');
  const { handleAboutSystemModal } = useUser();

  const menuItems: ISupportMenuItem[] = useMemo(() => {
    return [
      {
        label: t('USER_GUIDE'),
        to: envs.PATIENT_USER_GUIDE_URL,
        dataTestId: HEADER_DATA_TEST_ID.headerSupportMenuUserGuide,
      },
      {
        label: t('CONTACT_SUPPORT'),
        to: envs.PATIENT_CONTACT_SUPPORT_URL,
        dataTestId: HEADER_DATA_TEST_ID.headerSupportMenuContactSupport,
      },
      {
        label: 'About system',
        onClick: handleAboutSystemModal,
        dataTestId: HEADER_DATA_TEST_ID.headerProfileMenuAbout,
      },
    ];
  }, [handleAboutSystemModal, t]);

  return { menuItems };
};
